import { Box, Paper, Radio, Typography, useTheme } from "@material-ui/core";
import { ThemedAsset, assetIds } from "nemuru-components";
import React, { useEffect, useMemo, useState } from "react";
import { ICON_TITLE_HEIGHT } from "../../../../config/config";
import { formatIBAN } from "../../../../utils/formaters";
import IconTitle from "../../../shared/components/IconTitle";
import MainButton from "../../../shared/components/MainButton";
import Text from "../../../shared/components/Text";
import { useCashInCashOutMethod } from "./hooks/useCashInCashOutMethod";

export function CashInCashOutMethod() {
  const { palette, customBorderRadius } = useTheme();

  const {
    borrowerBankReader,
    getBorrowerBankReaderOrSkipModule,
    postAddCashInCashOutMethod,
    navigateToBorrowerBankReader,
  } = useCashInCashOutMethod();

  const [selectedBankAccountId, setBelectedBankAccountId] = useState();

  useEffect(() => {
    getBorrowerBankReaderOrSkipModule();
  }, []);

  useEffect(() => {
    if (!borrowerBankReader) return;
    if (!borrowerBankReader.bank_accounts.length) {
      navigateToBorrowerBankReader();
      return;
    }
    setBelectedBankAccountId(borrowerBankReader.bank_accounts[0].id);
  }, [borrowerBankReader]);

  const selectedAccountNumber = useMemo(() => {
    if (!borrowerBankReader || !selectedBankAccountId) return;
    return borrowerBankReader.bank_accounts.find(
      (bankAccount) => bankAccount.id === selectedBankAccountId
    )?.account_number;
  }, [selectedBankAccountId]);

  if (!borrowerBankReader) return <></>;

  const handleChange = (bankAccountId) => {
    setBelectedBankAccountId(bankAccountId);
  };

  return (
    <>
      <Box>
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_DATA_DUO}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="FINANCIAL_DATA" />}
          subtitle={<Text tId="BANK_ACCOUNT_IBAN" />}
        />
        <Box my={3} display={"flex"} justifyContent={"center"}>
          <Typography
            align={"center"}
            style={{ color: palette.text.title }}
            variant={"caption"}
          >
            <Text tId="SELECT_YOUR_BANK_ACCOUNT" />
          </Typography>
        </Box>
        {borrowerBankReader.bank_accounts.map((bankAccount) => (
          <Paper
            key={bankAccount.id}
            elevation={0}
            style={{ marginBottom: "16px" }}
          >
            <Box
              p={2}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              bgcolor={"grey.50"}
              borderRadius={customBorderRadius.paper}
              onClick={() => handleChange(bankAccount.id)}
              style={{ cursor: "pointer" }}
            >
              <Box>
                <Typography variant={"caption"} color={"textSecondary"}>
                  {bankAccount.account_name ?? "Número de cuenta"}
                </Typography>
                <Typography
                  variant={"body1"}
                  style={{ color: palette.text.title }}
                >
                  <strong>{formatIBAN(bankAccount.account_number)}</strong>
                </Typography>
              </Box>
              <Radio
                checked={selectedBankAccountId === bankAccount.id}
                value={bankAccount.id}
              />
            </Box>
          </Paper>
        ))}
      </Box>
      <Box>
        <MainButton
          onClick={() => postAddCashInCashOutMethod(selectedAccountNumber)}
        />
      </Box>
    </>
  );
}
